export default "__VITE_ASSET__DNlmFmas__"